import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import Close from '../../assets/svg/modal-close.svg'
import './modal.scss';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '1050px',
    zIndex: '99 !important',
    overflowY: 'hidden',
    height: 'min(640px,90%)',
    //maxHeight: 'min(640px,90%)',
    borderRadius: 18,
    padding: '36px 5px 20px 35px',
    border: 0,
  },
  overlay: {
    backgroundColor: 'rgba(0,0,0,0.36)',
  }
};

const ModalComponent = ({
  children,
  auto,
  closeSize,
  closeModal,
  closed,
  openModal,
  newstyles,
  showCloseButton,
  confirm,
  full,
  modalSecundario,
  preventClose = false,
  shouldCloseOnOverlayClick = true
}) => {


  useEffect(() => {

    // if(auto){
    //   customStyles.content.width = 'auto';
    //   customStyles.content.height = 'auto';
    //   customStyles.content.maxHeight = 'min(640px,90%)';
    //   customStyles.content.padding = '40px 49px 65px 62px';
    // }
    Modal.setAppElement('body');
    if (!closeSize) {
      //this.props.closeSize = "20px";
    }
  }, []);

  const fecharModal = () => {
    console.log("passou no close")
    if (!modalSecundario) {
      document.body.classList.remove('noOverflow');
    }

    if (closeModal) {
      closeModal()
    }
    // console.log(closed, typeof closed == 'function');
    if (typeof closed == 'function') {
      closed();
    }
  }

  const getClass = () => {
    if (full)
      return "gb-modal full";
    let c = auto ? "gb-modal auto" : "gb-modal";
    if (confirm)
      c = c + " confirm";
    return c + " m-1";
  }


  return (
    <div>

      <Modal
        isOpen={openModal}
        onRequestClose={fecharModal}
        style={newstyles}
        contentLabel="Exames"
        className={getClass()}
        overlayClassName={full ? "gb-overlay full" : "gb-overlay"}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >

        <div style={{ width: '100%', marginBottom: full ? '0' : '10px' }}>
          <a className="close"
            onClick={(ev) => { if (preventClose) { ev.preventDefault(); } fecharModal() }}
            /* href={window.location.href}  ENTENDER DEPOIS PORQUE COLOCARAM ISSO - 22-02-2024 */
            style={{ zIndex: 1, cursor: 'pointer', position: 'absolute', top: 12, right: 12 }}
          >
            {typeof (showCloseButton) === "undefined" || showCloseButton === null || showCloseButton ? (
              <img src={Close} height={29} />
            ) : null}
          </a>
        </div>
        <div className={full ? "gb-modal-content full" : "gb-modal-content"}>
          {children}
        </div>
      </Modal>
    </div>
  );

}

export default ModalComponent;